<template>
	<div v-if="me" class="row">
		<section class="col-12 mb-9">
			<section class="psdm-hero --action-dashboard">
				<div class="psdm-hero__gradient-wrapper">
					<div class="psdm-hero__bg-wrapper psdm-hero__bg-wrapper--desktop-only">
						<div class="container">
							<div class="psdm-hero__wrapper">
								<div class="psdm-hero__cop-breadcrumbs font_14_19">
									<a class="psdm-hero__cop-breadcrumb-link" href="/actions">Action platform</a>
									<a class="psdm-hero__cop-breadcrumb-link psdm-hero__cop-active-breadcrumb-link" href="#">Dashboard</a>
								</div>
								<div class="row justify-content-start">
									<div class="col-12 col-sm-<?php echo $data->title_width['size'] ?> <?php echo $data->align_text; ?>">
										<h3 class="psdm-hero__title">Welcome back, {{me.first_name}}</h3>
									</div>
								</div>
								<div class="row justify-content-start">
									<div class="col-12 col-sm-6 text-left">
										<p class="psdm-hero__text mb-7 mb-lg-10 text-white font_16_21">Continue on your journey to make commitments, share your actions and set targets for people and nature to flourish.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</section>
		<section class="col-12">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<h2 class="font_roboto font_24_32 font-weight-bold text-oceanblue mb-6">Your commitments</h2>
						<hr class="mb-10"/>
						<ps-expansion-panel v-for="theme in themes" :key="theme.id">
							<template slot="icon">
								<img :src="theme.icon" class="img-fluid w-100" :alt="theme.title" />
							</template>
							<div class="ml-4" slot="title">
								<h3 class="font_roboto font_18_24 font-weight-bold text-primary mb-0">
									{{theme.title}}
								</h3>
							</div>
							<div slot="body">
								<template v-if="myCommitmentsByTheme(theme.id).length">
									<ps-panel class="bg-lightestgrey pb-10" :border-top="index > 0" v-for="(commitmentProgress, index) in myCommitmentsByTheme(theme.id)" :key="commitmentProgress.commitment.id">
										<div class="d-flex align-items-center">
											<div class="flex-grow-1">
												<h4 class="font_roboto font_18_24 font-weight-bold text-primary ">{{commitmentProgress.commitment.title}}</h4>
												<p>{{getMyProgressPercentage(commitmentProgress.commitment.id)}}% Achieved</p>
												<ps-progress-bar :progress="getMyProgressPercentage(commitmentProgress.commitment.id)"/>
											</div>
											<a @click.prevent="showCommitmentDetail(commitmentProgress)" class="ml-25" href="#" style="width: 48px"
											   target="_self">
												<span class="sr-only">Go to commitment details</span>
												<icon-right-arrow-round color="#248A86"/>
											</a>
										</div>
									</ps-panel>
								</template>
								<ps-panel v-else class="bg-lightestgrey pb-10">
									<div class="d-flex align-items-center">
										<h3 class="font_roboto font_14_19 text-primary mb-0">You have not yet made any commitments within this action area. Click <a href="/commitments">here</a> to get started</h3>
									</div>
								</ps-panel>

							</div>
						</ps-expansion-panel>
					</div>
				</div>
			</div>
		</section>

		<ps-commitment-statistics v-if="commitmentStats" :themes="themes" :commitment-stats="commitmentStats" />

	</div>
</template>

<script>
	import MakeCommitmentMethods from '../../mixins/MakeCommitmentMethods'
	import commitmentThemesQuery from '../../graphql/queries/commitments.gql'
	import commitmentStatsQuery from '../../graphql/queries/commitmentStatsQuery.gql'
	import { mapGetters } from 'vuex';

	export default {
		name: "PsCommitmentsDashboard",
		data: () => ({
			themes: [],
			commitmentStats: {},
		}),
		apollo: {
			themes: {
				query: commitmentThemesQuery,
				update: data => data.commitmentThemes
			},
			commitmentStats: {
				query: commitmentStatsQuery,
				update: data => data.commitmentStats
			},
		},
		methods: {
			showCommitmentDetail(detail) {
				// this.activeTab = tab
				this.$store.commit('setCommitmentsActivePage', 'commitment-details')
				this.$store.commit('setCommitmentDashboardSelectedCommitment', detail)
			}
		},
		computed: {
			...mapGetters({
				me: 'getMe',
			}),
		},
		mounted() {
			window.scrollTo(0, 0)
		},
		mixins: [MakeCommitmentMethods]
	}
</script>

<style lang="scss" scoped>
	.c-dashboard-hero {
		padding-top: 40px;
		padding-right: 10px;
		padding-left: 10px;
		background-color: #5aa783;

		@include media-breakpoint-up(md) {
			padding-top: 60px;
			padding-right: 50px;
			padding-left: 50px;
			background: url('../../../../images/tree-right.png'), linear-gradient(88.5deg, rgba(36, 138, 134, 0.9) -16.92%, rgba(113, 185, 108, 0.9) 97.44%);
			background-repeat: no-repeat;
			background-position: right top;
			background-size: auto, 100% 400px;
		}
	}
</style>